export default "__VITE_ASSET__D2TGqLnC__"